module.exports = __webpack_public_path__ + "img/home.e0d4d875.png";